import type { UseQueryOptions, UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { TreatmentScheduleTemplate } from "../schemas/Treatment";

const queryKeyPrefix = "getTreatmentSchedule";
type QueryKey = readonly [typeof queryKeyPrefix, number];
const getTreatmentScheduleQueryKey = (treatmentScheduleID: number): QueryKey => [queryKeyPrefix, treatmentScheduleID];

export const useGetTreatmentSchedule = (
  treatmentScheduleID: number,
  options?: UseQueryOptions<TreatmentScheduleTemplate, Error, TreatmentScheduleTemplate, QueryKey>
): UseQueryResult<TreatmentScheduleTemplate, Error> => {
  const client = useApiClient();

  return useQuery(
    getTreatmentScheduleQueryKey(treatmentScheduleID),
    () => client.getTreatmentSchedule(treatmentScheduleID),
    options
  );
};
